export default __webpack_public_path__ + "static/media/calendar-shift.b13a3bec.svg";